/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_Title_AccentInputs */

const tr_landing_finalcta_title_accent = /** @type {(inputs: Landing_Finalcta_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sizin için çalışsın`)
};

const en_landing_finalcta_title_accent = /** @type {(inputs: Landing_Finalcta_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`work for you again`)
};

const de_landing_finalcta_title_accent = /** @type {(inputs: Landing_Finalcta_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`für Sie arbeiten`)
};

const ru_landing_finalcta_title_accent = /** @type {(inputs: Landing_Finalcta_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`работает на вас`)
};

/**
* | output |
* | --- |
* | "work for you again" |
*
* @param {Landing_Finalcta_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_title_accent = /** @type {((inputs?: Landing_Finalcta_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_title_accent(inputs)
	if (locale === "de") return de_landing_finalcta_title_accent(inputs)
	if (locale === "ru") return ru_landing_finalcta_title_accent(inputs)
	return tr_landing_finalcta_title_accent(inputs)
});